import moment from "moment-timezone";


// utils/formatting.js
export function toProperCase(str) {
    if (!str) return "";
    return str
        .toLowerCase()
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/(^|\s|-|\/)\S/g, (match) => match.toUpperCase());
}


export function formatFieldLabel(field) {
    if (!field) return "";

    return field
        .replace(/_/g, " ")             // convert snake_case → spaces
        .replace(/([A-Z])/g, " $1")     // split camelCase → spaces
        .replace(/\s+/g, " ")           // remove multiple spaces
        .trim()
        .split(" ")                     // capitalize each word
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}



export function convertToCST(timeStr, fromTz = "UTC") {
    let timeObj = moment.tz(timeStr, fromTz);
    let cstTime = timeObj.tz("America/Chicago");
    return cstTime.format("MMM DD, hh:mm A");
}


// // utils/formatting.js
// export function toProperCase(str) {
//     if (!str) return "";
//     return str
//         .toLowerCase()
//         .replace(/(^|\s|-|\/)\S/g, (match) => match.toUpperCase());
// }
